import { createSelector } from "@ngrx/store";
import { VistaUsuarioState, selectVistaUsuario } from "../../vista-usuario/vista-usuario.state";
import { EntityTipoEquipamientoLaboratorioState, entityTipoEquipamientoLaboratorioAdapter } from "./entity-tipos-equipamiento-laboratorio.state";

const { selectEntities, selectAll } = entityTipoEquipamientoLaboratorioAdapter.getSelectors();

export const getError = (state: EntityTipoEquipamientoLaboratorioState): any => state.error;

export const getIsLoading = (state: EntityTipoEquipamientoLaboratorioState): boolean =>
  state.isLoading;

export const selectTipoLaboratorioState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.tipoEquipamientoLaboratorio
);

export const selectAllTiposEquipamientoLaboratorio = createSelector(selectTipoLaboratorioState, selectAll);
